import { Component } from "@angular/core";
import { MetadataTextButtonComponent } from "./metadata-text-button.component";

@Component({
    selector: "metadata-icon-button",
    templateUrl: "./metadata-icon-button.tmpl.html",
    standalone: false
})
export class MetadataIconButtonComponent extends MetadataTextButtonComponent
{

}
